import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track11CBlack = ({ state, workState, onLabelClick }) => {
	const trackColor = getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK);
	return (
		<g id="Track11CBlack" transform="translate(2207.000000, 478.000000)" className="track">
			<g id="line" transform="translate(11.041508, 0.000000)" strokeLinecap="round" stroke={trackColor}
				 strokeWidth={tracksWidth}>
				<line x1="8.19277232" y1="36.7087001" x2="2.9584915" y2="143.5"/>

				<line x1="9.9584915" y1="0" x2="8.71114047" y2="25.932003"/>

				<TrackArrow
					transform="translate(8.958492, 23.000000) rotate(-89.000000) translate(-8.958492, -23.000000) "
					points="12.9584915 31 4.9584915 23 12.9584915 15"
				/>
			</g>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track11CBlack')}
				coords="0.000000, 45.937801"
				text='11C'
				textCoordsX="8.50927734"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			/>
		</g>
	);
};

Track11CBlack.propTypes = trackPropTypes;

export default Track11CBlack;
